import { RadioChecked, RadioUnchecked } from "@/components/icon/svg"
import { FormControlLabel, Radio as MuiRadio, RadioProps as MuiRadioProps } from "@mui/material"
import classNames from "classnames"

import "./radio.scss"

import { RadioProps } from "@/types/components/radio"
import { useState } from "react"

/**
 * 라디오 버튼만 렌더링하는 컴포넌트
 * @param props Mui의 라디오 프롭. https://mui.com/material-ui/react-radio/
 *
 */
export function BaseRadio(props: MuiRadioProps) {
  const [isHoveredState, setIsHovered] = useState(false)

  return (
    <MuiRadio
      {...props}
      className={classNames("BaseRadioCont", props.className, {
        isHovered: isHoveredState,
      })}
      disableRipple
      checkedIcon={<RadioChecked />}
      icon={<RadioUnchecked />}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    />
  )
}

/**
 * 라디오 버튼에 라벨을 선택적으로 렌더링하는 컴포넌트
 * @param RadioProps Mui의 라디오 프롭과 FormControlLabelProps 프롭중 control을 제외한 나머지 프롭을 받는다. https://mui.com/material-ui/api/form-control-label/
 *
 */
export default function Radio({ label, className, onRadioChange, ...props }: RadioProps) {
  const [checkboxClassName, setCheckboxClassName] = useState(className || "")

  const onMouseEnter = () => {
    setCheckboxClassName((className || "").concat(" isHovered"))
  }

  const onMouseLeave = () => {
    setCheckboxClassName(className || "")
  }

  return (
    <FormControlLabel
      {...props}
      label={label}
      className={classNames("RadioCont", className)}
      control={
        <BaseRadio
          {...props}
          disableRipple
          onChange={onRadioChange}
          className={checkboxClassName}
        />
      }
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  )
}
